import * as React from 'react'

import { Product } from 'even-ts-static'

import { Fields } from 'embed/constants/fields'

import { ApplicationField } from 'embed/components/ApplicationField/container'

const styles = require('./styles')

export const PersonalInfoFields = () => (
  <div className={styles.container}>
    <div className={styles.multipleInputsWrapper}>
      <div className={styles.wrapper}>
        <ApplicationField product={Product.LifeInsurance} field={Fields.FirstName} placeholder={'Enter First Name'} />
      </div>
      <div className={styles.wrapper}>
        <ApplicationField product={Product.LifeInsurance} field={Fields.LastName} placeholder={'Enter Last Name'} />
      </div>
    </div>
    <div className={styles.wrapper}>
      <ApplicationField product={Product.LifeInsurance} field={Fields.EmailAddress} placeholder={'Enter Your Email'} />
    </div>
    <div className={styles.wrapper}>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.PhoneNumber}
        label={'Preferred number to reach you'}
      />
    </div>
  </div>
)
